import type {ReactAction} from '@netx/core/bootstrap';
import {faLink} from '@fortawesome/pro-solid-svg-icons';
import {canCreateShareLinkFromSavedSearch} from '../enablers';
import {SEARCH_SAVED_ACTION_LABELS} from '../locales';
import {type SavedSearch} from '../types';
import {SEARCH_SAVED_EVENT} from './constants';

export const searchSavedActionShareLinkIcon = faLink;

/**
 * Saved search share link
 * @param params
 * @returns Action
 */
export const searchSavedActionShareLink = (
	savedSearch?: SavedSearch,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-search-share-link',
	cb: () => dispatcher.trigger(SEARCH_SAVED_EVENT.SHARE_LINK, savedSearch),
	enableTest: () => canCreateShareLinkFromSavedSearch(savedSearch),
	icon: searchSavedActionShareLinkIcon,
	get label() {
		return SEARCH_SAVED_ACTION_LABELS.SHARE_LINK;
	},
	...params,
});

export default searchSavedActionShareLink;
